import { RecommendationsEmpty } from './RecommendationCards'

export const RecommendationsForMyTeamsPage = () => <RecommendationsEmpty message="Рекомендации для команд появятся позже" />
